import { FC, useState } from 'react';
import { styled } from '../../../../theme/stitches.config';
import { SMPFlex } from '../../atoms/SMPFlex';
import { SMPText } from '../../atoms/SMPText';
import { SMPArrowUpIcon } from '../../atoms/icons/SMPArrowUpIcon';

export const Collapsible: FC<React.PropsWithChildren<{ text: string; initialState?: 'open' | 'closed'; verticalMode?: boolean }>> = ({
  children,
  text,
  initialState = 'open',
  verticalMode = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(initialState !== 'closed');

  return (
    <CollapsibleWrapper>
      <CollapsibleHeader onClick={() => setIsExpanded((prev) => !prev)} verticalMode={verticalMode} isExpanded={isExpanded}>
        <SMPText size={verticalMode ? '4' : '5'} variant='contrast' weight='600'>
          {text}
        </SMPText>
        <SMPFlex
          align='center'
          justify='center'
          css={{ width: '$5', height: '$5' }}
          style={{ transform: isExpanded ? 'unset' : 'rotate(180deg)' }}
        >
          <SMPArrowUpIcon css={{ width: '$2_5', height: '$2' }} />
        </SMPFlex>
      </CollapsibleHeader>
      {isExpanded && children}
    </CollapsibleWrapper>
  );
};

const CollapsibleWrapper = styled.withConfig({ componentId: 'Collapsible', displayName: 'CollapsibleWrapper' })('div', {
  marginTop: '0px',
});

const CollapsibleHeader = styled.withConfig({ componentId: 'Collapsible', displayName: 'CollapsibleHeader' })('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '$2_5 $3',
  width: '100%',
  backgroundColor: '$collapsibleBgColor',
  cursor: 'pointer',

  variants: {
    verticalMode: {
      true: {
        borderRadius: '0',
      },
      false: {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      },
    },
    isExpanded: {
      true: {},
      false: {},
    },
  },

  compoundVariants: [
    {
      verticalMode: false,
      isExpanded: false,
      css: {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
      },
    },
  ],
});
